/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { DashboardSummaryProps } from './DashboardSummary.props';

/**
 * SDS Dashboard Summary.
 */
export const DashboardSummary = (props: DashboardSummaryProps): JSX.Element => {
  const { children } = props;
  return (
    <div className="dashboard-summary">
      <div className="dashboard-summary__content">
        <div className="dashboard-summary__content-grid">{children}</div>
      </div>
    </div>
  );
};
